//
export const ATTACHMENT_IMG_WIDTH = 300
export const ATTACHMENT_IMG_HEIGHT = 300
